import { useQuery, useMutation } from "@apollo/client/react";
import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_PROGRAMA_KETO_NUTRICIONISTA, { adaptAddVisitaKetoNutricionistaInput } from "../../../../../../data/graphQL/mutations/Visitas/saveProgramaKetoNutricionista";
import { useStepSave } from "../../../../hooks/useStepSave";
import { filterVisitaData, getInputNames } from "../../../../utils/formDataHelper";
import CardBox from "../../CardBox/CardBox";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ProgramaKetoNutricionista({ readOnly, onSaveRef, onExposeFormatted, esUrgencia }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_PROGRAMA_KETO_NUTRICIONISTA);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (readOnly) newInput.disabled = true;
      if (esUrgencia) newInput.required = false;

      return newInput;
    });
  }, [readOnly, formData, esUrgencia]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAddVisitaKetoNutricionistaInput(formData) } });

    const idVisitaKeto = data?.saveVisitaKetoNutricionista?.idVisitaKeto;
    if (!idVisitaKeto) throw new Error("Error al guardar");

    setVisita((prev) => ({ ...prev, ...formData, idVisitaKeto }));
  });

  useEffect(() => {
    if (visita) {
      const inputNames = getInputNames(inputs);

      setFormData({
        ...filterVisitaData(visita, inputNames),
        idVisitaKeto: visita.idVisitaKeto,
        idVisita: visita.idVisita
      });
    }
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: "programaKetoNutricionista",
      stepName: "Programa Keto",
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.
          filter((input) => !input.hidden).
          map((input) =>
            <Grid size={{ xs: 12 }} key={input.name}>
              <RenderInputByTypeMobile
                input={input}
                value={formData[input.name]}
                handleChange={handleChange}
                row={input.type === "multiple_boolean"} />

            </Grid>
          )}
      </Grid>
    </CardBox>);

}

const inputs = [
  {
    name: "mismoRequerimiento",
    displayName: "¿Continua con los mismo requerimientos nutricionales?",
    type: "boolean",
    lightTitle: true,
    required: true
  },
  {
    name: "calorica",
    displayName: "Ingesta calórica actual",
    type: "boolean",
    opcionSiTexto: 'Adecuada',
    opcionNoTexto: 'Inadecuada',
    lightTitle: true,
    required: true
  },
  {
    name: "proteica",
    displayName: "Ingesta proteica actual",
    type: "boolean",
    opcionSiTexto: 'Adecuada',
    opcionNoTexto: 'Inadecuada',
    lightTitle: true,
    required: true
  },
  {
    name: "fosforo",
    displayName: "Ingesta de fósforo actual",
    type: "boolean",
    opcionSiTexto: 'Adecuada',
    opcionNoTexto: 'Inadecuada',
    lightTitle: true,
    required: true
  },
  {
    name: "potasio",
    displayName: "Ingesta de potasio actual",
    type: "boolean",
    opcionSiTexto: 'Adecuada',
    opcionNoTexto: 'Inadecuada',
    lightTitle: true,
    maxLength: 1000
  },
  {
    name: "sodio",
    displayName: "Ingesta de sodio actual",
    type: "boolean",
    opcionSiTexto: 'Adecuada',
    opcionNoTexto: 'Inadecuada',
    lightTitle: true,
    required: true
  },
  {
    name: "cantidad",
    displayName: "cantidad de Ketosteril que ingiere",
    type: "float",
    required: true
  }];